import api from "./api";

export async function getSkillCheck(processId) {
  return api.get(`/process/${processId}/skill-check`);
}
